import QuantityPickerContactsLeftAll from './QuantityPickerContactsLeftAll';
import QuantityPickerUsersLeftAll from './QuantityPickerUsersLeftAll';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuantityPickerContainerLeftAll = ({
  additionalUnitSkuIds,
  setProductLevel,
  trackingSource,
  productLevel
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(QuantityPickerUsersLeftAll, {
      additionalUnitSkuIds: additionalUnitSkuIds,
      trackingSource: trackingSource
    }), /*#__PURE__*/_jsx(QuantityPickerContactsLeftAll, {
      additionalUnitSkuIds: additionalUnitSkuIds,
      setProductLevel: setProductLevel,
      trackingSource: trackingSource,
      productLevel: productLevel
    })]
  });
};
export default QuantityPickerContainerLeftAll;